module.exports = __webpack_public_path__ + "static/media/photo-section.1063b33b.png";